import { FunctionComponent } from 'react';
import { Modal, Image} from 'react-bootstrap';
import cn from 'classnames';
import styles from "./LocationReviewModal.module.css";
import CustomButton, { ButtonRadiusSize, ButtonType } from '../../../../../component/common/CustomButton/CustomButton';
import { ASSESTS } from '../../../../../constant/assest';
import FormTextArea from '../../../../../component/common/FormField/FormTextArea';
import FormField, { IFieldTheme, IFieldType } from '../../../../../component/common/FormField/FormField';


interface IProps {
    showModal: boolean;
    onClose: () => void;
    className?: string;
};

const LocationReviewModal: FunctionComponent<IProps> = ({showModal, onClose, className}) => {
  return (
    <Modal 
        show={showModal} 
        className={cn(styles.addModal, className)}
        dialogClassName={styles.addModalDialog}
        contentClassName={styles.addModalContent}
        centered={true}
    >
        <CustomButton
            className={styles.modalCloseBtn}
            btnType={ButtonType.IMAGE}
            onClick={onClose}
        >
            <Image src={ASSESTS.CLOSEPOPUP}  alt="Close" />
        </CustomButton>
        <Modal.Header bsPrefix={styles.header}>
          <Modal.Title bsPrefix={styles.title} as={'div'}>Location Details: Crystal Lake</Modal.Title>
        </Modal.Header>
        <Modal.Body bsPrefix={styles.body}>
            <FormField
                label={'Location Name'}
                placeholder='Location Name'
                fieldTheme={IFieldTheme.LIGHT2} 
                fieldType={IFieldType.TEXT}
                showEditIcon={true}
                editIcon={<>
                    <Image
                        src={ASSESTS.EDITICON}
                        width={20}
                        height={20}
                        alt={"Edit"}
                    />
                </>}
            />
            <FormField
                label={'Coordinates'}
                placeholder='Coordinates 00.00, 00.00'
                fieldTheme={IFieldTheme.LIGHT2} 
                fieldType={IFieldType.TEXT}
            />
            <div className={styles.tagsWrap}>
                <div className={styles.label}>Tags</div>
                <div className={styles.tags}>
                    <span className={styles.lakeTag}>bass</span>
                    <span className={styles.lakeTag}>trout</span>
                    <span className={styles.lakeTag}>popular</span>
                </div>
            </div>
            <div className={styles.reviewTextWrap}>
                <div className={styles.reviewText}>Pending Review: Submitted by angler_mike</div>
            </div>
        </Modal.Body>
        <Modal.Footer bsPrefix={styles.footer}>
            <CustomButton
                className={styles.addMoreBtn}
                btnType={ButtonType.LIGHTBLUE}
                btnRadius={ButtonRadiusSize.SMALL}
            >
                Save Location
            </CustomButton>
            <CustomButton
                className={styles.addBtn}
                btnType={ButtonType.GREEN}
                btnRadius={ButtonRadiusSize.SMALL}
            >
                View Fish Data
            </CustomButton>
        </Modal.Footer>
    </Modal>
  );
}

export default LocationReviewModal;